<template>
  <a-drawer
    :maskClosable="false"
    width="35%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    :destroyOnClose="true"
    @close="onCloseConfirm(() => (open = false))"
  >
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>

    <LoadingPop v-if="showLoading" ref="LoadingPop" @ok="showLoading = false" />

    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="投诉内容" prop="name">
        <a-input
          v-model="form.name"
          placeholder="请输入"
          :maxLength="50"
          allowClear
        />
      </a-form-model-item>

      <a-form-model-item label="状态" prop="status">
        <a-radio-group v-model="form.status" button-style="solid">
          <a-radio-button :value="1">启用</a-radio-button>
          <a-radio-button :value="0">禁用</a-radio-button>
        </a-radio-group>
      </a-form-model-item>

      <a-form-model-item label="备注" prop="remark">
        <a-textarea
          v-model="form.remark"
          placeholder="请输入"
          :maxLength="150"
          :rows="3"
          allowClear
        />
      </a-form-model-item>

      <a-form-model-item label="排序" prop="sort">
        <a-input
          v-model="form.sort"
          placeholder="请输入"
          :maxLength="20"
          allowClear
          @input="form.sort = form.sort.replace(/[^\d]/g, '')"
        />
      </a-form-model-item>

      <div class="bottom-control">
        <a-space>
          <a-button
            type="primary"
            :loading="submitLoading"
            @click="submitForm"
          >
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">取消</a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getObj, addObj, putObj } from '@/api/maintenance/repairSort/index.js'

export default {
  name: 'CreateForm',

  props: {
    statusOptions: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      open: false,
      submitLoading: false,
      showLoading: false,
      formTitle: '',
      form: {
        id: undefined,
        name: undefined,
        remark: undefined,
        parentId: '0',
        status: 1,
        sort: 99,
      },
      rules: {
        name: [
          { required: true, message: '请输入投诉内容', trigger: 'blur' },
        ],
        status: [
          { required: true, message: '请选择状态', trigger: 'change' },
        ],
        sort: [
          { required: true, message: '请输入排序', trigger: 'blur' },
        ],
      },
    }
  },

  methods: {
    /* 对外暴露的新增接口 */
    handleAdd(row) {
      this.reset()
      this.open = true
      if (row) {
        this.form.parentId = row.id
        this.formTitle =
          row.parentId == 0 ? '添加二级维修投诉分类' : '添加三级维修投诉分类'
      } else {
        this.form.parentId = '0'
        this.formTitle = '添加一级维修投诉分类'
      }
    },

    /* 对外暴露的修改接口 */
    handleUpdate(row, ids) {
      this.reset()
      const postId = row ? row.id : ids
      getObj(postId).then(({ data }) => {
        this.form = { ...data, parentId: Number(data.parentId) }
        this.open = true
        this.formTitle = '修改维修投诉分类'
      })
    },

    submitForm() {
      this.$refs.form.validate((valid, object) => {
        if (!valid) {
          const messages = Object.values(object)
            .flat()
            .map(o => o.message)
          this.showLoading = true
          this.$nextTick(() => this.$refs.LoadingPop.init(2, messages))
          return
        }

        this.submitLoading = true
        this.showLoading = true
        this.$nextTick(() => this.$refs.LoadingPop.init(1))

        const req = this.form.id ? putObj(this.form) : addObj(this.form)
        req
          .then(() => {
            this.$message.success(this.form.id ? '修改成功' : '新增成功', 3)
            this.open = false
            this.$emit('ok')
          })
          .finally(() => {
            this.submitLoading = false
            this.showLoading = false
          })
      })
    },

    cancel() {
      this.onCloseConfirm(() => (this.open = false))
    },

    onCloseConfirm(cb) {
      this.$confirm({
        title: '是否确认关闭并清空数据？',
        onOk: () => {
          this.reset()
          cb && cb()
        },
      })
    },

    reset() {
      this.form = {
        id: undefined,
        name: undefined,
        remark: undefined,
        parentId: '0',
        status: 1,
        sort: 99,
      }
    },
  },
}
</script>

<style lang="less" scoped>
.bottom-control {
  text-align: right;
  padding-top: 16px;
}
</style>
